import { Command, ICommandResult } from '@/_core/cqrs/types/commands';

export class UpdateUserNotificationSettingsCommand extends Command<ICommandResult> {
    constructor(public Settings: any) {
        super('UpdateUserNotificationSettings');
    }
}

export class SlackDisconnectCommand extends Command<ICommandResult> {
    constructor() {
        super('SlackDisconnect');
    }
}
